import { render } from "./Toolbar.vue?vue&type=template&id=0e71b1a0&scoped=true&color=red"
import script from "./Toolbar.vue?vue&type=script&lang=js"
export * from "./Toolbar.vue?vue&type=script&lang=js"

import "./Toolbar.vue?vue&type=style&index=0&id=0e71b1a0&lang=css"
import "./Toolbar.vue?vue&type=style&index=1&id=0e71b1a0&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0e71b1a0"]])

export default __exports__